import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Input from '../../Input';
const EditTableCell = _ref => {
  let {
    column,
    initialValue = '',
    inputProps,
    row,
    table,
    onInputChange
  } = _ref;
  const [restInputProps, setRestInputProps] = useState(inputProps);
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    setRestInputProps(inputProps);
  }, [inputProps]);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  const onBlur = () => {
    var _a;
    (_a = table.options.meta) === null || _a === void 0 ? void 0 : _a.updateData(row.index, column.id, value);
  };
  const onClear = () => {
    setValue('');
    if (typeof column.columnDef.meta.inputProps === 'function') {
      setRestInputProps(column.columnDef.meta.inputProps(row.original, column, ''));
    }
    if (onInputChange) {
      onInputChange('', row.index, column.id);
    }
  };
  const handleChange = e => {
    e.preventDefault();
    setValue(e.currentTarget.value);
    setRestInputProps(column.columnDef.meta.inputProps(row.original, column.columnDef, e.currentTarget.value));
    if (onInputChange) {
      onInputChange(e, row.index, column.id);
    }
  };
  return _jsx(_Fragment, {
    children: _jsx(Input, _extends({
      id: column.id,
      value: value,
      onChange: handleChange,
      onBlur: onBlur,
      onClear: onClear
    }, restInputProps))
  });
};
export default EditTableCell;